import { numberWithCommas, numberWithPeriods } from '../Utils/Utils';

const ACFBlockCounters = (domEl) => {

	// Get all counters
	const counters = domEl.querySelectorAll('.counter');

	// Observe the counters so we won't start 'em before they enter the view
	let observer = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {

				if(/*entry.intersectionRatio !== 0 || */entry.isIntersecting) {
					entry.target.classList.add('js-inview-initialized');

					animateValue(entry.target.querySelector('.number'),
						parseFloat(entry.target.getAttribute('data-from')),
						parseFloat(entry.target.getAttribute('data-to')),
						parseFloat(entry.target.getAttribute('data-duration')),
						entry.target.getAttribute('data-delimiter'));

					observer.unobserve(entry.target);
				}
			});
		},
		{rootMargin: "0px 0px -80px 0px"});


	const animateValue = (obj, start, end, duration, delimiter) => {

		let startTimestamp = null;
		const step = (timestamp) => {
			if (!startTimestamp) startTimestamp = timestamp;
			const progress = Math.min((timestamp - startTimestamp) / duration, 1);
			const newValue = Math.floor(progress * (end - start) + start);
			if(delimiter === 'period' ) {
				obj.innerHTML = numberWithPeriods(newValue);
			}
			else if(delimiter === 'comma' ) {
				obj.innerHTML = numberWithCommas(newValue);
			}
			else {
				obj.innerHTML = newValue;
			}

			if (progress < 1) {
				window.requestAnimationFrame(step);
			}
		};
		window.requestAnimationFrame(step);
	};

	// Set small timeout so the dom elements have time to get to their starting position before coming into .in-view position
	setTimeout(() => {
		counters.forEach((counter) => {
			observer.observe(counter);
		});
	}, 100);

};

export default ACFBlockCounters;